module.exports = __webpack_public_path__ + "img/img2.2314f0f8.png";